var React = require('react');

function ProfileIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"44","height":"44","fill":"#FF4552","rx":"22","key":0}),React.createElement("path",{"fill":"#FFF","d":"M24.626 25.5v-1.75c.393-.196 1.52-1.536 1.638-2.583.31-.024.796-.308.94-1.431.076-.603-.23-.942-.415-1.048 0 0 .462-.878.462-1.938 0-2.124-.834-3.937-2.625-3.937 0 0-.623-1.313-2.626-1.313-3.711 0-5.25 2.381-5.25 5.25 0 .966.462 1.938.462 1.938-.185.106-.492.446-.415 1.048.144 1.123.63 1.407.94 1.43.118 1.048 1.245 2.388 1.638 2.584v1.75c-.875 2.625-7.875.875-7.875 7h21c0-6.125-7-4.375-7.874-7z","key":1})]));
}

ProfileIcon.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44"};

module.exports = ProfileIcon;

ProfileIcon.default = ProfileIcon;
